import { render, staticRenderFns } from "./UserRule.vue?vue&type=template&id=25bc538a&scoped=true&"
var script = {}
import style0 from "./UserRule.vue?vue&type=style&index=0&id=25bc538a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bc538a",
  null
  
)

export default component.exports